import { getInstance, init, loadRemote } from '@module-federation/enhanced/runtime';

export const STUDIO_REMOTE = 'http://127.0.0.1:5740/mf-manifest.json';
export const STUDIO_BASENAME = '/gosh/studio';

export type StudioNavItem = {
  path: string;
  name: string;
  icon: string;
};

type NavModule = {
  studioNav?: StudioNavItem[];
};

export function ensureStudioRuntime() {
  if (getInstance()) return;
  init({
    name: 'ghostoreAdmin',
    remotes: [
      {
        name: 'goshStudio',
        entry: STUDIO_REMOTE,
      },
    ],
  });
}

let navTask: Promise<StudioNavItem[]> | null = null;

/** 左侧菜单跟子应用的 studioNav 走，失败时下次再拉。 */
export function loadStudioNav() {
  if (!navTask) {
    navTask = (async () => {
      ensureStudioRuntime();
      const mod = await loadRemote<NavModule>('goshStudio/nav');
      return mod?.studioNav ?? [];
    })().catch((err: unknown) => {
      navTask = null;
      throw err;
    });
  }
  return navTask;
}
